import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      
      <main className="container mx-auto px-6 pt-24 pb-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        <div className="max-w-3xl mx-auto">
          <header className="mb-12">
            <h1 className="text-4xl md:text-5xl font-display font-bold mb-4">
              Ice<span className="text-primary">Hub</span> Privacy Policy
            </h1>
            <p className="text-muted-foreground">
              Last updated: January 2026
            </p>
          </header>

          <section className="mb-10">
            <p className="text-lg text-muted-foreground leading-relaxed">
              IceHub is a web-based ice hockey information app providing schedules, scores, and broadcast guides. 
              We respect your privacy and collect minimal data.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-display font-semibold mb-4 text-foreground">
              Information We Collect
            </h2>
            <ul className="space-y-3 text-muted-foreground">
              <li className="flex items-start gap-3">
                <span className="text-primary mt-1.5">•</span>
                <span>No personal data is collected directly through normal app usage.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary mt-1.5">•</span>
                <span>The app may use browser storage (localStorage) for your preferences, such as favorite leagues or language settings.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary mt-1.5">•</span>
                <span>If you sign up for alerts or create an account, we collect your email address only for the purpose of sending notifications and managing your subscription.</span>
              </li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-display font-semibold mb-4 text-foreground">
              Third-Party Services
            </h2>
            <ul className="space-y-3 text-muted-foreground">
              <li className="flex items-start gap-3">
                <span className="text-primary mt-1.5">•</span>
                <span>We may use external APIs to fetch sports data. These requests are anonymous and do not include personal information.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary mt-1.5">•</span>
                <span>No advertisements or third-party trackers are currently used on this platform.</span>
              </li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-display font-semibold mb-4 text-foreground">
              Data Sharing
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              We do not sell, trade, or share your personal data with third parties. Your information stays with us and is used solely for providing you with the best ice hockey experience.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-display font-semibold mb-4 text-foreground">
              Changes to This Policy
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              We may update this privacy policy from time to time. Any changes will be reflected on this page with an updated revision date. We encourage you to check back periodically.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-display font-semibold mb-4 text-foreground">
              Contact Us
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Questions about this privacy policy? Reach out to us:
            </p>
            <ul className="mt-3 space-y-2 text-muted-foreground">
              <li className="flex items-center gap-3">
                <span className="text-primary">•</span>
                <span>Email: <a href="mailto:ptsthlm@gmail.com" className="text-primary hover:underline">ptsthlm@gmail.com</a></span>
              </li>
              <li className="flex items-center gap-3">
                <span className="text-primary">•</span>
                <span>X (Twitter): <a href="https://x.com/pt_sthlm" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">@pt_sthlm</a></span>
              </li>
            </ul>
          </section>

          <section className="p-6 rounded-xl bg-primary/10 border border-primary/20">
            <h2 className="text-xl font-display font-semibold mb-3 text-foreground">
              GDPR Compliance
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              IceHub is based in Stockholm, Sweden and is fully compliant with the European Union's General Data Protection Regulation (GDPR). 
              You have the right to access, correct, or delete any personal data we may hold about you. Contact us to exercise these rights.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;
